export default "__VITE_ASSET__B5JoqJIX__"